import { classInstance } from '@/shared/helpers/helpers';

class Button {
	private readonly button;

	constructor(element) {
		if (!element) return;

		this.button = element;

		this.init();
	}

	private setBeforeCoordinates = (offsetX, offsetY): void => {
		this.button.style.setProperty('--before-left', `${offsetX}px`);
		this.button.style.setProperty('--before-top', `${offsetY}px`);
	};

	private handleMouseEnter = ({ offsetX, offsetY }): void => this.setBeforeCoordinates(offsetX, offsetY);

	private handleMouseLeave = ({ offsetX, offsetY }): void => this.setBeforeCoordinates(offsetX, offsetY);

	init = (): void => {
		classInstance.set(this.button, { button: this });

		this.button.addEventListener('mouseenter', this.handleMouseEnter);
		this.button.addEventListener('mouseleave', this.handleMouseLeave);
	};
}

export { Button };
